import { render, staticRenderFns } from "./HistamineTypeToggle.vue?vue&type=template&id=f69d896c&"
import script from "./HistamineTypeToggle.vue?vue&type=script&lang=js&"
export * from "./HistamineTypeToggle.vue?vue&type=script&lang=js&"
import style0 from "./HistamineTypeToggle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports